import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "id", "isControlled", "isDisabled", "isInline", "isInvalid", "label", "mode", "name", "onBlur", "onChange", "onFocus", "options", "selectedValue", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Children, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Radio from '../Radio';
import { Styled } from './RadioGroup.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RadioGroup = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      id = _ref.id,
      _ref$isControlled = _ref.isControlled,
      isControlled = _ref$isControlled === void 0 ? false : _ref$isControlled,
      isDisabled = _ref.isDisabled,
      isInline = _ref.isInline,
      isInvalid = _ref.isInvalid,
      label = _ref.label,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      name = _ref.name,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return null;
  } : _ref$onFocus,
      optionsFromProp = _ref.options,
      selectedValueFromProp = _ref.selectedValue,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-radioGroup"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useState = useState(function () {
    if (optionsFromProp) {
      return optionsFromProp;
    } else if (children) {
      return Children.toArray(children);
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = useState(selectedValueFromProp),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedValue = _useState4[0],
      setSelectedValue = _useState4[1];

  var handleChange = function handleChange(event, newSelectedValue) {
    !isControlled && setSelectedValue(newSelectedValue);
    onChange(event, newSelectedValue);
  };

  var handleFocus = function handleFocus(event) {
    return onFocus(event);
  };

  var handleBlur = function handleBlur(event) {
    return onBlur(event);
  };

  var renderOptions = function renderOptions() {
    return options.map(function (option) {
      var radio = optionsFromProp ? option : children ? option.props : null;
      return _jsxs(Radio, {
        isChecked: radio.value === selectedValue,
        isDisabled: isDisabled || radio.disabled,
        isInvalid: isInvalid,
        label: radio.label,
        name: name,
        onBlur: function onBlur(event) {
          return handleBlur(event);
        },
        onChange: function onChange(event) {
          return handleChange(event, radio.value);
        },
        onFocus: function onFocus(event) {
          return handleFocus(event);
        },
        value: radio.value,
        children: [radio.description || radio.children, radio.render && radio.value === selectedValue && _jsx(Styled.RadioGroupContent, {
          children: radio.render()
        })]
      }, radio.value);
    });
  };

  useEffect(function () {
    if (optionsFromProp) {
      setOptions(optionsFromProp);
    } else if (children) {
      setOptions(Children.toArray(children));
    }
  }, [optionsFromProp, children]);
  useEffect(function () {
    setSelectedValue(selectedValueFromProp);
  }, [selectedValueFromProp]);
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(Styled.RadioGroup, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className,
      isInline: isInline,
      isDisabled: isDisabled,
      role: "group"
    }, rest), {}, {
      children: renderOptions()
    }))
  });
});
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;